module.exports = __webpack_public_path__ + "img/制御工学3_6_1.8f0573dd.png";